import type { ReactNode } from 'react';
import { Icon, type IconName } from '@zarya/theme';
import { t } from '@app/i18n';
import s from './Approvals.module.css';

export type KpiTone = 'danger' | 'warning' | 'success' | 'primary' | 'neutral';

export interface KpiProps {
  label: string;
  valor: number;
  tone?: KpiTone;
  detalhe?: ReactNode;
  icon?: IconName;
}

/**
 * Indicador do topo de T9 (`kpi()` do protótipo, §2.3).
 *
 * Vive aqui e não em `@zarya/ui` porque só esta tela o usa hoje; quando a Visão
 * geral (T3) precisar do mesmo bloco, ele sobe para o design system.
 */
export function Kpi({ label, valor, tone = 'neutral', detalhe, icon }: KpiProps) {
  return (
    <div className={s.kpi}>
      <div className={s.kpiHd}>
        <span className={s.kpiLabel}>{label}</span>
        {icon ? <Icon name={icon} size="sm" className={s.kpiIcon} aria-hidden="true" /> : null}
      </div>
      <span className={s.kpiValor} data-tone={tone} aria-label={t('approvals.page.kpi.ariaLabel', { label, n: valor })}>
        {valor}
      </span>
      {detalhe ? <span className={s.kpiDetalhe}>{detalhe}</span> : null}
    </div>
  );
}
